// SPの求人詳細の画像スライド
import Splide from '@splidejs/splide';
import '@splidejs/splide/css';

export function initMainCarousel() {
  const thumbnails = document.querySelectorAll('.splide__thumbnail');
  if (!thumbnails.length) return;

  const splide = new Splide('#main-carousel', {
    pagination: false,
  });

  splide.mount();

  thumbnails.forEach((thumbnail, index) => {
    initThumbnail(splide, thumbnail, index);
  });

  // サムネの連動のためmoveイベントのリスナーを一度だけ追加
  splide.on('move', function () {
    // 現在アクティブなサムネイルをリセット
    const current = document.querySelector('.splide__thumbnail.is-active');
    if (current) {
      current.classList.remove('is-active');
    }

    // Splide#indexは現在アクティブなスライドのインデックスを返す
    const thumbnail = thumbnails[splide.index];

    if (thumbnail) {
      thumbnail.classList.add('is-active');
    }
  });
}

// それぞれのリスト要素を初期化するための関数
function initThumbnail(splide, thumbnail, index) {
  thumbnail.addEventListener('click', function () {
    splide.go(index);
  });
}
